const actions = {
  ORGANIZATION_ADD_BEGIN: 'ORGANIZATION_ADD_BEGIN',
  ORGANIZATION_ADD_SUCCESS: 'ORGANIZATION_ADD_SUCCESS',
  ORGANIZATION_ADD_ERR: 'ORGANIZATION_ADD_ERR',
  
  ORGANIZATIONS_READ_BEGIN: 'ORGANIZATIONS_READ_BEGIN',
  ORGANIZATIONS_READ_SUCCESS: 'ORGANIZATIONS_READ_SUCCESS',
  ORGANIZATIONS_READ_ERR: 'ORGANIZATIONS_READ_ERR',

  ORGANIZATION_UPDATE_BEGIN: 'ORGANIZATION_UPDATE_BEGIN',
  ORGANIZATION_UPDATE_SUCCESS: 'ORGANIZATION_UPDATE_SUCCESS',
  ORGANIZATION_UPDATE_ERR: 'ORGANIZATION_UPDATE_ERR',

  ORGANIZATION_DELETE_BEGIN: 'ORGANIZATION_DELETE_BEGIN',
  ORGANIZATION_DELETE_SUCCESS: 'ORGANIZATION_DELETE_SUCCESS',
  ORGANIZATION_DELETE_ERR: 'ORGANIZATION_DELETE_ERR',

  ORGANIZATION_READ_BEGIN: 'ORGANIZATION_READ_BEGIN',
  ORGANIZATION_READ_SUCCESS: 'ORGANIZATION_READ_SUCCESS',
  ORGANIZATION_READ_ERR: 'ORGANIZATION_READ_ERR',

  ORGANIZATION_UPLOAD_BEGIN: 'ORGANIZATION_UPLOAD_BEGIN',
  ORGANIZATION_UPLOAD_SUCCESS: 'ORGANIZATION_UPLOAD_SUCCESS',
  ORGANIZATION_UPLOAD_ERR: 'ORGANIZATION_UPLOAD_ERR',

  SEARCH_ORGANIZATION_BEGIN: 'SEARCH_ORGANIZATION_BEGIN',
  SEARCH_ORGANIZATION_SUCCESS: 'SEARCH_ORGANIZATION_SUCCESS',
  SEARCH_ORGANIZATION_ERR: 'SEARCH_ORGANIZATION_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.ORGANIZATIONS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.ORGANIZATIONS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.ORGANIZATIONS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.ORGANIZATION_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.ORGANIZATION_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.ORGANIZATION_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.ORGANIZATION_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.ORGANIZATION_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.ORGANIZATION_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.ORGANIZATION_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.ORGANIZATION_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.ORGANIZATION_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.ORGANIZATION_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.ORGANIZATION_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.ORGANIZATION_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.ORGANIZATION_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.ORGANIZATION_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.ORGANIZATION_UPLOAD_ERR,
      err,
    };
  },

  searchOrganizationBegin: () => {
    return {
      type: actions.SEARCH_ORGANIZATION_BEGIN,
    };
  },

  searchOrganizationSuccess: (data) => {
    return {
      type: actions.SEARCH_ORGANIZATION_SUCCESS,
      data,
    };
  },

  searchOrganizationErr: (err) => {
    return {
      type: actions.SEARCH_ORGANIZATION_ERR,
      err,
    };
  },

};

export default actions;
